import { identityApiUrl } from '@/config/authSession';

/**
 * A call of the identity service's PUBLIC routes (`/identity/api/v1/...`):
 * no token, no assignment header, no cookies. Used only by the pages a person
 * reaches without signing in (the invitation link, Request access). Answers
 * the parsed body, or a refusal-shaped object when nothing usable came back.
 */
export async function publicIdentityRequest(
  path: string,
  body: Record<string, unknown>,
): Promise<unknown> {
  if (!identityApiUrl) return { success: false, status: 0, message: 'identity_api_not_configured' };
  const base = identityApiUrl.endsWith('/') ? identityApiUrl : `${identityApiUrl}/`;
  try {
    const response = await fetch(base + path.replace(/^\/+/, ''), {
      method: 'POST',
      cache: 'no-store',
      credentials: 'omit',
      headers: { accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    try {
      return await response.json();
    } catch {
      return { success: false, code: response.status, message: 'request_failed' };
    }
  } catch {
    return { success: false, status: 0, message: 'network' };
  }
}
